/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Solver_StartInputs */

const en_cp_solver_start = /** @type {(inputs: Cp_Solver_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from a problem owner (small business, village office, campus unit) and one success metric.`)
};

const id_cp_solver_start = /** @type {(inputs: Cp_Solver_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari pemilik masalah (UMKM, desa, unit kampus) dan satu ukuran keberhasilan.`)
};

/**
* | output |
* | --- |
* | "Start from a problem owner (small business, village office, campus unit) and one success metric." |
*
* @param {Cp_Solver_StartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_solver_start = /** @type {((inputs?: Cp_Solver_StartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Solver_StartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_solver_start(inputs)
	return en_cp_solver_start(inputs)
});